module.exports = __webpack_public_path__ + "img/ic_nosmoke.629dedd2.svg";